// fetchChatroomMessagesWithDynamicLimit.js
'use strict';
import 'isomorphic-fetch';

import getListData from '../selector/getListData.js';
import fetchChatroomMessages from './fetchChatroomMessages.js';
import getDynamicPageLimit from '../resource/getDynamicPageLimit.js';

/**
 * Fetch chatroom messages with dynamic limit
 * @param {string} { id } - chatroom id.
 * @param {number} {[page = 1]} - the page number.
 * @param {boolean} {[shouldResetList = false]} - should reset list.
 * @param {boolean} {[isFetchMediaOnly = false]} - is only fetch media messages
 * @return {Promise} Action promise.
 */
const fetchChatroomMessagesWithDynamicLimit =
  ({ id, page = 1, shouldResetList = false, isFetchMediaOnly = false }) =>
  async (dispatch, getState) => {
    if (!id) {
      return dispatch({
        type: '',
      });
    }

    const listSelectPath = isFetchMediaOnly
      ? ['chatroom', id, 'mediaOnly']
      : ['chatroom', id, 'messages'];
    const limit = getDynamicPageLimit(
      getListData(getState(), listSelectPath, 'totalCount')
    );

    await dispatch(
      fetchChatroomMessages({
        id,
        page,
        limit,
        shouldResetList,
        isFetchMediaOnly,
      })
    );

    const newLimit = getDynamicPageLimit(
      getListData(getState(), listSelectPath, 'totalCount')
    );
    if (limit !== newLimit) {
      // refetch messages with new limit value
      await dispatch(
        fetchChatroomMessages({
          id,
          page,
          limit: newLimit,
          shouldResetList,
          isFetchMediaOnly,
        })
      );
    }
  };

export default fetchChatroomMessagesWithDynamicLimit;
